import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
const initialState = [];
export const snackbarSlice = createSlice({
    name: 'snackbar',
    initialState,
    reducers: {
        enqueueSnackbar: (state, action) => {
            state.push(Object.assign({ key: uuidv4() }, action.payload));
        },
        removeSnackbar: (state, action) => {
            state = state.filter((notification) => notification.key !== action.payload);
        },
    },
});
export const { enqueueSnackbar, removeSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
